import { Component, OnInit } from '@angular/core';
import { SEOService } from '../services/seo.service';

@Component({
  selector: 'app-approfondimenti',
  templateUrl: './approfondimenti.component.html',
  styleUrls: ['./approfondimenti.component.scss']
})

export class ApprofondimentiComponent implements OnInit {
  pageTitle = "Approfondimenti | Leone Lifestyle";
  desc = "La nuova era della nutrizione e del benessere"
  shareImg = "blog/masthead-blog.jpg";

  constructor(private seo: SEOService) {}

  ngOnInit() { 
    this.seo.updatePageTags(this.pageTitle, this.desc, this.shareImg);
  }

  // I NUOVI ARTICOLI VANNO INSERITI IN TESTA!
  articles = [
    {
      title: "CODICE GIALLO",
      author: "GIOVEDÌ 21 LUGLIO 2022",
      section: "#APPROFONDIMENTI",
      src: "assets/approfondimenti/codice-giallo-thumb.jpg",
      url: "approfondimenti/codice-giallo"
    },
    {
      title: "RICOMINCIO DAL DRIN",
      author: "GIOVEDÌ 25 FEBBRAIO 2021",
      section: "#APPROFONDIMENTI",
      src: "assets/approfondimenti/ricomincio-thumb.jpg",
      url: "approfondimenti/ricomincio-dal-drin"
    },
    {
      title: "AS WE LIKE IT: ",
      subtitle: "COME PIU' CI PIACE",
      author: "SABATO 15 NOVEMBRE 2020",
      section: "#APPROFONDIMENTI",
      src: "assets/approfondimenti/as-we-like-it-thumb.jpg",
      url: "approfondimenti/as-we-like-it"
    },
    {
      title: "DIETA CHETOGENICA: ",
      subtitle: "CONTENERE L’IPERGLICEMIA E LA TEMPESTA CITOCHINICA CHE CARATTERIZZA IL QUADRO ACUTO DA COVID19",
      author: "SABATO 15 NOVEMBRE 2020",
      section: "#APPROFONDIMENTI",
      src: "assets/approfondimenti/dieta-chetogenica-thumb.jpg",
      url: "approfondimenti/dieta-chetogenica"
    }
  ]
}
